import { LitElement, html, svg } from 'lit';

export class IconNewAd16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Ark med bilde, overskrift og fremhevet plusstegn</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 11v4M11 13h4M12 4H4v3h8V4ZM4 11h5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 9V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h7"></path></svg>`; }
}
if (!customElements.get('f-icon-new-ad16', IconNewAd16)) {
  customElements.define('f-icon-new-ad16', IconNewAd16);
}